import React from "react";
import { Phone } from "lucide-react";
import { SITE } from "../../site.config";

export default function MobileCallBar() {
  return (
    <a
      href={`tel:${SITE.business.phoneTel}`}
      data-testid="mobile-call-sticker"
      aria-label={`Call Powerz Auto Electrical on ${SITE.business.phone}`}
      className="md:hidden fixed bottom-4 left-4 right-4 z-50 flex items-center justify-center gap-3 bg-cyan-pz text-black py-4 bebas text-2xl tracking-[0.15em] shadow-[0_0_28px_rgba(94,230,230,0.55)] clip-perf pulse-cyan active:scale-[0.98] transition-transform"
      style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}
    >
      <Phone className="w-6 h-6" />
      CALL {SITE.business.phone}
    </a>
  );
}
